import React from 'react';
import { Link } from 'react-router-dom'; // Importer Link pour la navigation

const Header = ({ titre, sous_titre, sous_titre1, entete, sous_titre2, user_id }) => {
  return (
    <div>
      <div className="row wrapper border-bottom white-bg page-heading">
        <div className="col-lg-12">
          <h2>{titre}</h2>
          <ol className="breadcrumb custom-breadcrumb">
            <li className="breadcrumb-item custom-breadcrumb-item">
              {/* Utiliser Link de react-router-dom pour la navigation */}
              <Link to={`/dashboard`}>{sous_titre}</Link>
            </li>
            <li className="breadcrumb-item custom-breadcrumb-item pl-1">
              <strong>{sous_titre1}</strong>
            </li>
            <li className="breadcrumb-item custom-breadcrumb-item pl-1">
              <strong>{entete}</strong>
            </li>
            {/* <li className="breadcrumb-item active">
                <strong>{sous_titre2}</strong>
              </li> */}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Header;
